import React, { useEffect } from 'react';
import { Card, Typography, Space } from 'antd';
import { BarChartOutlined } from '@ant-design/icons';
import { Container } from 'react-bootstrap';
import activityTracker from '../user/ActivityTracker';
import usePageTracking from '../../utils/usePageTracking';

const { Title } = Typography;

function StockComparison() {
  // GA4 页面追踪
  usePageTracking('股票比較');
  
  useEffect(() => {
    activityTracker.trackPageView('stock_comparison');
  }, []);

  return (
    <Container fluid className="mt-4">
      <Card>
        <Space direction="vertical" align="center" style={{ width: '100%', padding: '40px 0' }}>
          <BarChartOutlined style={{ fontSize: '48px', color: '#1890ff' }} />
          <Title level={2}>個股比較</Title>
          <Title level={4} type="secondary">開發中 敬請期待</Title>
        </Space>
      </Card>
    </Container>
  );
}

export default StockComparison; 